export default __webpack_public_path__ + "static/media/habano6.fd7925ff.png";